export default[
    {
        path: '/dataList',
        component: resolve => require(['../index.vue'], resolve),
        meta: {
            title: '数据中心',
            keepAlive: false
        }
    }
]